import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
} from 'reactstrap';
import {
  offerDetailsFetchData,
  offerRuleFetchData,
  addNewOfferRuleData,
  updateOfferRuleData,
  removeOfferRuleData,
  supplierItemListFetchData,
} from '../../actions/offerActions';
import { dealFunderListFetchData } from '../../actions/regionActions';
import Moment from 'moment';
import { Link, useParams } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import NoRowExistsRow from '../../components/common/noRowExistsRow';

const RulePage = () => {
  const dispatch = useDispatch();
  const { offerId, campaignId, promotionId } = useParams();

  const offerDetails = useSelector((state) => state.offerDetails ?? []);
  const ruleList = useSelector((state) => state.offerRule ?? []);
  const dealFunderList = useSelector((state) => state.dealFunderList ?? []);
  const isLoadingDetails = useSelector(
    (state) => state.offerDetailsIsLoading ?? true,
  );

  const [formState, setFormState] = useState({
    ruleName: '',
    ruleType: '4',
    batchType: 1,
    accountType: '',
    operatorField: '',
    operatorAmount: '',
    transactionType: '',
    funder: '',
    doubleDip: false,
  });

  const [isSubmitBtnEnabled, setIsSubmitBtnEnabled] = useState(true);
  const [isFunderEnabled, setIsFunderEnabled] = useState(true);
  const [isOperatorFieldEnabled, setIsOperatorFieldEnabled] = useState(false);
  const [isOutputFormatFieldEnabled, setIsOutputFormatFieldEnabled] =
    useState(true);
  const [isOperatorAmountEnabled, setIsOperatorAmountEnabled] = useState(false);
  const [operatorAmountInputType, setOperatorAmountInputType] =
    useState('text');
  const [isTransactionTypeEnabled, setIsTransactionTypeEnabled] =
    useState(false);
  const [isAccountTypeEnabled, setIsAccountTypeEnabled] = useState(true);
  const [isDoubleDipEnabled, setIsDoubleDipEnabled] = useState(false);
  const [isRuleMethodEnabled, setIsRuleMethodEnabled] = useState(true);

  const ruleTypeList = [
    { ruleTypeCode: 4, ruleType: 'Unit Fixed from CAF' },
    { ruleTypeCode: 5, ruleType: 'Total Discount' },
  ];
  const accountTypeList = [
    { accountCode: 1, accountName: 'Store' },
    { accountCode: 2, accountName: 'Funder' },
  ];
  const operatorFieldList = [
    { fieldCode: 1, fieldName: 'Base Price' },
    { fieldCode: 2, fieldName: 'Amount' },
    { fieldCode: 3, fieldName: 'Percentage (%)' },
  ];
  const transactionTypeList = [
    { transactionTypeId: 1, transactionTypeName: 'Dr' },
    { transactionTypeId: 2, transactionTypeName: 'Cr' },
  ];
  const batchTypeList = [
    { batchTypeId: 1, batchTypeName: 'Market Pulse' },
    { batchTypeId: 4, batchTypeName: 'SAP iDoc' },
  ];

  useEffect(() => {
    dispatch(offerDetailsFetchData(offerId));
    dispatch(offerRuleFetchData(offerId));
    dispatch(dealFunderListFetchData());
  }, [dispatch, offerId]);

  useEffect(() => {
    if (
      ruleList &&
      ruleList.length > 0 &&
      ruleList.filter((x) => x.ruleType === 'TotalDiscount').length > 0
    ) {
      setFormState((fs) => ({
        ...fs,
        ruleName: ruleList[0].description,
        ruleType: '5',
        batchType: 4,
      }));
      setIsSubmitBtnEnabled(false);
    } else {
      setFormState((fs) => ({
        ...fs,
        ruleName: '',
        ruleType: '4',
        batchType: 1,
      }));
      setIsSubmitBtnEnabled(true);
      setIsRuleMethodEnabled(false);
    }
    if (ruleList && ruleList.length === 0) {
      setIsRuleMethodEnabled(true);
    }
  }, [ruleList]);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    let newValue = type === 'checkbox' ? checked : value;
    setFormState((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    if (name === 'operatorAmount' && formState.accountType === '1') {
      if (value < 0) newValue = 0;
      else if (value > 100) newValue = 100;
      setFormState((prev) => ({ ...prev, operatorAmount: newValue }));
    }

    setFormState((prev) => ({ ...prev, batchType: 1 }));

    if (name === 'accountType') handleAccountTypeChange(newValue);
    if (name === 'ruleType') handleRuleTypeChange(newValue);
  };

  const handleRuleTypeChange = (value) => {
    if (value === '5') {
      setFormState((fs) => ({
        ...fs,
        batchType: 4,
        accountType: '1',
        operatorField: '',
        operatorAmount: '',
      }));
      setIsOutputFormatFieldEnabled(false);
      setIsFunderEnabled(false);
      setIsAccountTypeEnabled(false);
      setIsDoubleDipEnabled(false);
      setIsOperatorFieldEnabled(false);
      setIsOperatorAmountEnabled(false);
      setIsTransactionTypeEnabled(false);
      handleAccountTypeChange(null);
    } else if (value === '4') {
      setIsFunderEnabled(true);
      setIsOperatorFieldEnabled(false);
      setIsOutputFormatFieldEnabled(true);
      setIsOperatorAmountEnabled(false);
      setIsTransactionTypeEnabled(false);
      setIsAccountTypeEnabled(true);
      setFormState((fs) => ({
        ...fs,
        operatorField: '',
        operatorAmount: '',
        accountType: '',
        transactionType: '',
      }));
    } else {
      setIsFunderEnabled(true);
      setIsOperatorFieldEnabled(true);
      setIsOperatorAmountEnabled(true);
      setIsTransactionTypeEnabled(true);
      setIsAccountTypeEnabled(true);
    }
  };

  const handleAccountTypeChange = (value) => {
    setIsFunderEnabled(value === '2');
    setIsDoubleDipEnabled(value === '2');
    setIsOperatorFieldEnabled(false);
    setIsOperatorAmountEnabled(value === '1');
    setFormState((fs) => ({
      ...fs,
      funder: '',
      doubleDip: false,
      operatorField: value === '1' ? '3' : '',
      operatorAmountInputType: value === '1' ? 'number' : 'text',
      operatorAmount:
        value === '1' ? (!fs.operatorAmount ? 100 : fs.operatorAmount) : '',
    }));
    setOperatorAmountInputType(value === '1' ? 'number' : 'text');
  };

  const handleAddNewSubmit = (e) => {
    e.preventDefault();
    const operatorAmount =
      !formState.operatorAmount || formState.operatorAmount === ''
        ? null
        : formState.operatorAmount;
    const newOfferRule = {
      OfferId: offerId,
      name: formState.ruleName,
      accountid:
        !formState.accountType || formState.accountType === ''
          ? null
          : formState.accountType,
      ruleType:
        !formState.ruleType || formState.ruleType === ''
          ? null
          : formState.ruleType,
      OperatorField:
        !formState.operatorField || formState.operatorField === ''
          ? null
          : formState.operatorField,
      OperatorAmount: null,
      DealFunderId:
        !formState.funder || formState.funder === '' ? null : formState.funder,
      TransactionType:
        !formState.transactionType || formState.transactionType === ''
          ? null
          : formState.transactionType,
      batchType:
        !formState.batchType || formState.batchType === ''
          ? null
          : formState.batchType,
      allowDoubleDip:
        !formState.doubleDip || formState.doubleDip === ''
          ? null
          : formState.doubleDip,
    };
    if (formState.accountType === '1' && operatorAmount != null) {
      newOfferRule.OperatorAmount = operatorAmount / 100;
    }
    dispatch(addNewOfferRuleData(newOfferRule));
  };

  const handleRuleChange = (event, rule) => {
    const { name, value, type, checked } = event.target;
    rule[name] = type === 'checkbox' ? checked : value;
    handleUpdateRule(rule);
  };

  const handleUpdateRule = (rule) => {
    const updatedOfferRule = {
      Id: rule.id,
      AllowDoubleDip:
        !rule.allowDoubleDip || rule.allowDoubleDip === ''
          ? null
          : rule.allowDoubleDip,
    };
    dispatch(updateOfferRuleData(updatedOfferRule));
  };

  const handleRemoveRule = (rule) => {
    dispatch(removeOfferRuleData(rule, offerId));
  };

  const renderRuleRow = (rule) => {
    const allowDoubleDipCheckBox =
      rule.accountTypeId === 2 ? (
        <FormGroup check>
          <Input
            type='checkbox'
            name='allowDoubleDip'
            defaultChecked={rule.allowDoubleDip}
            onChange={(e) => handleRuleChange(e, rule)}
          />
          <Label check for='allowDoubleDip'>
            Allow Double Dip
          </Label>
        </FormGroup>
      ) : null;

    const fieldValues =
      rule.operatorSourceField !== null ? (
        <div>
          <div> Field: {rule.operatorSourceField}</div>
          <div> Amount: {rule.operatorAmount}</div>
          <div> Trnx: {rule.transactionType}</div>
        </div>
      ) : null;

    const operatorAmountFieldValue =
      rule.accountType === 'Store' ? (
        <div>
          {' '}
          Percentage(%):{' '}
          {(rule.operatorAmount == null ? 1 : rule.operatorAmount) * 100}{' '}
        </div>
      ) : null;

    const addProductButton =
      rule.accountType !== 'Store' ? (
        <Link
          to={`/campaign/${campaignId}/promotions/${promotionId}/offers/${offerId}/rules/${rule.id}?ruleName=${rule.description}&offerName=${offerDetails.name}`}
          className='btn btn-primary mb-sm-2'
        >
          Set Products
        </Link>
      ) : null;

    return (
      <Row className='promotion-row' key={rule.id}>
        <Col md='3' className='white-border pb-1 pt-1'>
          <div>
            {' '}
            {rule.id} - {rule.description}
          </div>
          <div> Rule: {rule.ruleType}</div>
        </Col>
        <Col md='2' className='white-border pb-1 pt-1'>
          {rule.accountType} {rule.supplierName}
        </Col>
        <Col md='2' className='white-border pb-1 pt-1'>
          {fieldValues}
          {operatorAmountFieldValue}
        </Col>
        <Col md='3' className='white-border pb-1 pt-1'>
          {rule.products
            ? rule.products.map((prodt, i) => (
                <div key={i}>
                  {prodt.barcode} - {prodt.name}
                </div>
              ))
            : null}
        </Col>
        <Col md='2' className='white-border pb-1 pt-1'>
          {addProductButton}
          &nbsp;
          <button
            onClick={() => handleRemoveRule(rule)}
            className='btn btn-primary mb-sm-2'
          >
            Remove Rule
          </button>
          &nbsp;
          {allowDoubleDipCheckBox}
        </Col>
      </Row>
    );
  };

  const rulesRowHeader =
    ruleList && ruleList.length > 0 ? (
      <Row>
        <Col md='3' className='column-header'>
          Name
        </Col>
        <Col md='2' className='column-header'>
          Account Type / Funder
        </Col>
        <Col md='2' className='column-header'>
          Fields
        </Col>
        <Col md='3' className='column-header'>
          Products
        </Col>
        <Col md='2' className='column-header'></Col>
      </Row>
    ) : null;

  const rulesRows =
    ruleList && ruleList.length > 0 ? (
      ruleList.map((rule) => renderRuleRow(rule))
    ) : (
      <NoRowExistsRow emptyRowText='No rules exist' />
    );

  const campaignRow =
    offerDetails.campaignName === undefined ? null : (
      <Card className='card'>
        <CardBody>
          <CardSubtitle>Campaign : {offerDetails.campaignName}</CardSubtitle>
          <CardText></CardText>
          <CardSubtitle>Promotion : {offerDetails.promotionName}</CardSubtitle>
          <CardText></CardText>
        </CardBody>
      </Card>
    );

  return (
    <div>
      <Container fluid>
        <Row>
          <Col>
            <h4>Manage Rules for Offer</h4>
          </Col>
        </Row>
        <Row>
          <Col md='6' sm='12'>
            <Card className='card'>
              <CardBody>
                <CardTitle>{offerDetails.name}</CardTitle>
                <CardSubtitle>
                  {offerDetails.externalId} {offerDetails.status}
                </CardSubtitle>
                <CardText>
                  {Moment(offerDetails.startDate).format('DD MMM YYYY')} -{' '}
                  {Moment(offerDetails.endDate).format('DD MMM YYYY')}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col md='3' sm='12'>
            {campaignRow}
          </Col>
        </Row>
        <Row>
          <Col className='section-heading'>
            {' '}
            <h5> Add a new rule</h5>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className='card'>
              <CardBody>
                <Form onSubmit={handleAddNewSubmit}>
                  <Container fluid>
                    <Row>
                      <Col md='6'>
                        <FormGroup>
                          <Label for='ruleName'>Rule Name</Label>
                          <Input
                            id='ruleName'
                            name='ruleName'
                            value={formState.ruleName}
                            required
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for='ruleType'>Rule Method</Label>
                          <Input
                            type='select'
                            name='ruleType'
                            onChange={handleInputChange}
                            value={formState.ruleType}
                            required
                            disabled={!isRuleMethodEnabled}
                            className={'form-control'}
                          >
                            {ruleTypeList.map((ot) => (
                              <option
                                key={ot.ruleTypeCode}
                                value={ot.ruleTypeCode}
                              >
                                {ot.ruleType}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md='3'>
                        <FormGroup>
                          <Label for='BatchType'>Output Format</Label>
                          <Input
                            type='select'
                            name='batchType'
                            onChange={handleInputChange}
                            value={formState.batchType}
                            required
                            disabled={!isOutputFormatFieldEnabled}
                            className={'form-control'}
                          >
                            {batchTypeList.map((ot) => (
                              <option
                                key={ot.batchTypeId}
                                value={ot.batchTypeId}
                              >
                                {ot.batchTypeName}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md='3'>
                        <FormGroup>
                          <Label for='account'>Account Type</Label>
                          <Input
                            required
                            type='select'
                            name='accountType'
                            onChange={handleInputChange}
                            disabled={!isAccountTypeEnabled}
                            value={formState.accountType || ''}
                            className={'form-control'}
                          >
                            <option value='' disabled>
                              Account Type
                            </option>
                            {accountTypeList.map((acc) => (
                              <option
                                key={acc.accountCode}
                                value={acc.accountCode}
                              >
                                {acc.accountName}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for='OperatorField'>Operator Field</Label>
                          <Input
                            type='select'
                            name='operatorField'
                            onChange={handleInputChange}
                            value={formState.operatorField}
                            disabled={!isOperatorFieldEnabled}
                            className={'form-control'}
                          >
                            <option value='' disabled>
                              Operator field
                            </option>
                            {operatorFieldList.map((ot) => (
                              <option key={ot.fieldCode} value={ot.fieldCode}>
                                {ot.fieldName}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for='OperatorAmount'>Operator Amount</Label>
                          <Input
                            id='OperatorAmount'
                            type={operatorAmountInputType}
                            name='operatorAmount'
                            onChange={handleInputChange}
                            disabled={!isOperatorAmountEnabled}
                            value={formState.operatorAmount}
                            min='0'
                            max='100'
                            step='0.01'
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for='TransactionType'>Dr/Cr</Label>
                          <Input
                            type='select'
                            name='transactionType'
                            onChange={handleInputChange}
                            value={formState.transactionType}
                            disabled={!isTransactionTypeEnabled}
                            className={'form-control'}
                          >
                            <option value='' disabled>
                              Dr/Cr
                            </option>
                            {transactionTypeList.map((ot) => (
                              <option
                                key={ot.transactionTypeId}
                                value={ot.transactionTypeId}
                              >
                                {ot.transactionTypeName}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md='3'>
                        <FormGroup>
                          <Label for='funder'>Funder</Label>
                          <Input
                            type='select'
                            name='funder'
                            value={formState.funder}
                            onChange={handleInputChange}
                            disabled={!isFunderEnabled}
                            className={'form-control'}
                          >
                            <option value='' disabled>
                              Funder
                            </option>
                            {dealFunderList ? (
                              dealFunderList.map((ot) => (
                                <option key={ot.id} value={ot.id}>
                                  {ot.name}
                                </option>
                              ))
                            ) : (
                              <option key='' value=''>
                                select
                              </option>
                            )}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md='6'>
                        <FormGroup>
                          <Label for='doubleDip'>&nbsp;</Label>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type='checkbox'
                                name='doubleDip'
                                checked={formState.doubleDip}
                                onChange={handleInputChange}
                                disabled={!isDoubleDipEnabled}
                              />{' '}
                              Allow Double Dip
                            </Label>
                          </FormGroup>
                        </FormGroup>
                      </Col>
                      <Col md='3'>
                        <Label for='submitButton'>&nbsp;</Label>
                        <Input
                          id='submitButton'
                          type='submit'
                          disabled={!isSubmitBtnEnabled}
                        />
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col className='section-heading'>
            {' '}
            <h5> List of rules</h5>
          </Col>
        </Row>
        <Card className='card'>
          <CardBody>
            <Container fluid>
              {rulesRowHeader}
              {isLoadingDetails ? (
                <BeatLoader color={'#004C5F'} loading />
              ) : (
                rulesRows
              )}
            </Container>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

RulePage.propTypes = {
  // All state from redux
};

export default RulePage;
